var map = {
	"./act_as_toggle_controller.js": 72,
	"./document_form_controller.js": 73,
	"./hello_controller.js": 75,
	"./modal_controller.js": 76,
	"./partecipation_controller.js": 77,
	"./tagify_controller.js": 78
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71;